import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetItemDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Item/GetDetail?` + params, null);

export const GetItemList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Item/GetList?` + params, null);

export const CreateItem = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Item/Create`, data);

export const UpdateItem = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Item/Update`, data);

export const DeleteItem = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Item/Delete`, data);

export const UpdateOPDReasonforVisit = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Item/UpdateOPDReasonforVisit`, data);

export const GetItemAndProcedureList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Item/GetItemAndProcedureList?` + params, null);
